import { render } from "./pointsView.vue?vue&type=template&id=d9b37612"
import script from "./pointsView.vue?vue&type=script&lang=js"
export * from "./pointsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__